import Checkbox from '@material-ui/core/Checkbox/Checkbox';
import { BaseComponent } from 'components/BaseComponent';
import Translate from 'components/Translate';
import React from 'react';
import { WithStyles } from 'shared/decorators/withStyles';

@WithStyles(() => ({
  component: {
    '& .chk-acceptTerms__span': {
      fontSize: '0.750rem',
      margin: '10px 0 0 0',
      '& span': {
        width: '30px',
        height: '20px',
        '& svg': {
          color: '#000',
          width: '20px',
          height: 'auto'
        }
      }
    }
  }
}))
export default class AcceptTerms extends BaseComponent {
  render() {
    return (
      <div className={this.props.classes.component}>
        <div className="chk-acceptTerms__span">
          <Checkbox disabled checked value="checkedE" />
          <Translate term="Concordo que li, e compreendi os" />
          &nbsp;
          <a id="chk-accept-term" href="https://g.eduzz.com/gateway/termosrec" target="_blank">
            <Translate term="termos de assinatura e cancelamento" />
          </a>
        </div>
      </div>
    );
  }
}
